import { RoomData } from './Room';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { LineSeg2d } from '@/editor/math/LineSeg2d';
import { getPointAndClosedRelation } from '@/editor/math/shape/path';
import { EPointAndClosedRelation } from '@/editor/types/shape';
import { getPathFromEdges } from '@/editor/utils/edge';

export function getRoomRelateWallIds(roomData: RoomData) {
  const pathWallIds = roomData.corePathInfos.map((edge) => edge.wallId);
  const holeWallIds = roomData.coreHoleInfos.flatMap((edges) => edges.map((edge) => edge.wallId));

  const relateWallIds = Array.from(new Set([...pathWallIds, ...holeWallIds]));

  return relateWallIds;
}

export function getRoomId(roomDatas: RoomData[], point: IPoint2d) {
  for (const roomData of roomDatas) {
    const roomPath = getPathFromEdges(roomData.pathInfos);
    const roomHolePaths = roomData.holeInfos.map((holes) => getPathFromEdges(holes));

    if (!roomPath.length) continue;

    const inRoomOutline = getPointAndClosedRelation(point, roomPath) !== EPointAndClosedRelation.Outside;
    const isInRoomHoles = roomHolePaths.some(
      (hole) =>
        getPointAndClosedRelation(point, hole) !== EPointAndClosedRelation.Outside &&
        getPointAndClosedRelation(point, hole) !== EPointAndClosedRelation.On
    );

    if (inRoomOutline && !isInRoomHoles) return roomData.id;
  }
}

export function getRoomInnerSegs(roomDatas: RoomData[]) {
  const segs: LineSeg2d[] = [];

  for (const roomData of roomDatas) {
    const floorPaths = [
      roomData.pathInfos.map((info) => info.start),
      ...roomData.holeInfos.map((holes) => holes.map((hole) => hole.start))
    ];
    for (const floorPath of floorPaths) {
      const len = floorPath.length;
      for (let i = 0; i < len; i++) {
        segs.push(new LineSeg2d(floorPath[i], floorPath[(i + 1) % len]));
      }
    }
  }

  return segs;
}
